<template>
  <div>
    <el-form :disabled="readonly" class="section top" style="flex-direction: row;min-width: 1600px;">
      <el-checkbox v-model="job.warehousing" no="1" @change="loadingTerm_Change('warehousing')">{{ $t('SeaExport.Storage') }}</el-checkbox>
      <el-checkbox v-model="job.comercialInspectation" no="2">{{ $t('SeaExport.CommodityInspection') }}</el-checkbox>
    </el-form>
    <tab-ae-booking-UICustom-layout :element-blocks="elementBlocks">
      <el-form-item v-if="elementDict.jobNo.visible" slot="jobNo">
        <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
        <el-input v-model="job.jobNo" no="3" :disabled="true" class="job-no-color" />
      </el-form-item>
      <el-form-item v-if="elementDict.warehouseNo.visible" slot="warehouseNo">
        <line-label slot="label" :class="elementDict.warehouseNo.isRequire ? 'blue' : ''" :label="elementDict.warehouseNo.label" />
        <el-input v-model="job.warehouseNo" :disabled="readonly" no="4" />
      </el-form-item>
      <el-form-item v-if="elementDict.quotationNo.visible" slot="quotationNo">
        <line-label slot="label" :class="elementDict.quotationNo.isRequire ? 'blue' : ''" :label="elementDict.quotationNo.label" />
        <el-input no="5" :value="job.quotationNo" class="input2" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.customerRefNo.visible" slot="customerRefNo">
        <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
        <cargo-input v-model="job.customerRefNo" :disabled="readonly" no="6" :trim="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.customerId.visible" slot="customerId">
        <line-label slot="label" :class="elementDict.customerId.isRequire ? 'blue' : ''" :label="elementDict.customerId.label" />
        <cargo-sales-company-select
          v-if="accountObjectControlMode === 2"
          no="7"
          :disabled="!(!job.mbl&&electricBusinessBtnEnable) || readonly"
          :method-params="{customer:true,active:true}"
          :check-credit="true"
          :job="job"
          :default-value="job.customerId||''"
          :placeholder="$t('SeaExport.RequiredItem')"
          style="width: 100%"
          @parentCallBack="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
        />
        <cargo-company-select
          v-else
          no="7"
          :disabled="!(!job.mbl&&electricBusinessBtnEnable) || readonly"
          :method-params="{customer:true,active:true}"
          :check-credit="true"
          :job="job"
          :default-value="job.customerId||''"
          :static-options="customerCmpList"
          :placeholder="$t('SeaExport.RequiredItem')"
          style="width: 100%"
          @change="p=>{txtCustomerId_changeHandler(p);clearPoNo()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.customerContact.visible" slot="customerContact">
        <line-label slot="label" :class="elementDict.customerContact.isRequire ? 'blue' : ''" :label="elementDict.customerContact.label" />
        <el-select
          v-model="job.customerContact"
          no="8"
          :disabled="!electricBusinessBtnEnable || readonly"
          filterable
          :allow-create="true"
          placeholder=""
          @change="tfLinkman_closeHandler"
        >
          <el-option
            v-for="(item,index) in contactList"
            :key="index"
            :label="item.contactPerson"
            :value="item.contactPerson"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.contactTelephone.visible" slot="contactTelephone">
        <line-label slot="label" :class="elementDict.contactTelephone.isRequire ? 'blue' : ''" :label="elementDict.contactTelephone.label" />
        <el-input
          v-model="job.contactTelephone"
          no="9"
          :disabled="!electricBusinessBtnEnable || readonly"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.contactFax.visible" slot="contactFax">
        <line-label slot="label" :class="elementDict.contactFax.isRequire ? 'blue' : ''" :label="elementDict.contactFax.label" />
        <el-input
          v-model="job.contactFax"
          no="10"
          :disabled="!electricBusinessBtnEnable || readonly"
          maxlength="32"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.sales.visible" slot="sales">
        <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
        <cargo-user-select
          no="11"
          :disabled="lockSales||!(!job.trustFromJob&&electricBusinessBtnEnable&&(!validateCustomerSales||(isSpecifiedSalesBusiness&&validateCustomerSales))) || readonly"
          :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
          :default-value="job.sales||''"
          :static-options="salesList"
          :placeholder="$t('SeaExport.RequiredItem')"
          @change="txtSales_changeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.txtSalesOffice.visible" slot="txtSalesOffice">
        <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
        <el-input v-model="txtSalesOffice" no="12" :disabled="true" :placeholder="$t('SeaExport.RequiredItem')" />
      </el-form-item>
      <el-form-item v-if="elementDict.salesDepartment.visible" slot="salesDepartment">
        <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
        <cargo-department-new-select
          no="salesDepartment"
          :disabled="!job.sales || readonly"
          :enables="true"
          :sales-id="Number(job.sales)"
          :office-id="Number(job.salesOffice)"
          :department-id="Number(job.salesDepartment)"
          @change="departmentChargeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csr.visible" slot="csr">
        <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
        <cargo-user-select
          no="13"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :method-params="{category:'role',shape:'csr',officeId:job.opOffice}"
          :default-value="job.csr||''"
          :static-options="userPortRoleData.csr || csrList"
          placeholder=" "
          @change="csrChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.overseaOp.visible" slot="overseaOp">
        <line-label slot="label" :class="elementDict.overseaOp.isRequire ? 'blue' : ''" :label="elementDict.overseaOp.label" />
        <cargo-user-select
          ref="overseaOp"
          no="overseaOp"
          :disabled="readonly"
          class="input2"
          placeholder=" "
          :default-value="job.overseaOp||''"
          :method-params="{category:'role',shape:'overseaOp'}"
          :static-options="isHc ? null : (userPortRoleData.overseaOp || overseaAgentUsersList)"
          :merge-load="true"
          @change="p=>{
            job.overseaOp = p.value
            OverseaCustomerUtils.overseaOpChangeHandler(view, p)
          }"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.operateType.visible" slot="operateType">
        <line-label slot="label" :class="elementDict.operateType.isRequire ? 'blue' : ''" :label="elementDict.operateType.label" />
        <cargo-advance-select
          no="14"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.local_cache_AirExportConstants$BUSINESS_MODELS"
          :default-value="job.operateType"
          :clearable="false"
          style="width: 100%"
          @parentCallBack="p=>{job.operateType=p.value;onOperateTypeChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.op.visible" slot="op">
        <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
        <cargo-user-select
          no="15"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOfficeId}"
          :default-value="job.op||''"
          placeholder=" "
          :static-options="userPortRoleData.op"
          @change="txtOPChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opDepartment.visible" slot="opDepartment">
        <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
        <cargo-department-select
          no="16"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :office-id="job.opOffice"
          :department-id="job.opDepartment"
          placeholder=" "
          @change="p=>{job.opDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.opOffice.visible" slot="opOffice">
        <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
        <cargo-advance-select
          no="17"
          :disabled="isEntrustOrder() || readonly"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.opOffice||''"
          placeholder=" "
          @parentCallBack="p=>{job.opOffice=p.value;opOfficeChargeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSalesId.visible" slot="cargoSalesId">
        <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
        <cargo-user-select
          no="18"
          :disabled="readonly"
          :method-params="{category:'role',shape:'salesOfGoods'}"
          :default-value="job.cargoSalesId||''"
          :static-options="cargoSalesList"
          placeholder=" "
          @change="cargoSalesChargeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dc.visible" slot="dc">
        <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
        <cargo-user-select
          no="104"
          class="input2"
          :disabled="Boolean(job.trustFromJob) || readonly"
          :method-params="{category:'role',shape:'doc',officeId:$store.getters.currentOfficeId}"
          :default-value="job.dc||''"
          :static-options="userPortRoleData.doc || dcList"
          placeholder=" "
          @change="dcChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.siteOP.visible" slot="siteOP">
        <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
        <cargo-user-select
          no="19"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
          :default-value="job.siteOP||''"
          placeholder=" "
          :static-options="userPortRoleData.siteOp"
          @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.planner.visible" slot="planner">
        <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
        <cargo-user-select
          no="20"
          :disabled="readonly"
          :method-params="{category:'role',shape:'airline',officeId:currentOffice.code==='HB'?null:currentOffice.officeId}"
          :default-value="job.planner||''"
          placeholder=" "
          :static-options="userPortRoleData.airline"
          @change="txtPlannerChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrDepartment.visible" slot="csrDepartment">
        <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
        <cargo-department-select
          no="csrDepartment"
          :disabled="readonly"
          class="input2"
          :office-id="Number(job.csrOffice)"
          :enables="true"
          :department-id="Number(job.csrDepartment)"
          @change="p=>{job.csrDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.csrOffice.visible" slot="csrOffice">
        <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
        <cargo-advance-select
          no="csrOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.csrOffice||''"
          @parentCallBack="p=>{job.csrOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcDepartment.visible" slot="dcDepartment">
        <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
        <cargo-department-select
          no="dcDepartment"
          :disabled="readonly"
          class="input2"
          :office-id="Number(job.dcOffice)"
          :enables="true"
          :department-id="Number(job.dcDepartment)"
          @change="p=>{job.dcDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.dcOffice.visible" slot="dcOffice">
        <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
        <cargo-advance-select
          no="dcOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.dcOffice||''"
          @parentCallBack="p=>{job.dcOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.poNo.visible" slot="poNo" :class="poNoRed?'poNoClass':''">
        <line-label slot="label" :class="elementDict.poNo.isRequire ? 'blue' : ''" :label="elementDict.poNo.label" />
        <el-input v-if="!openProjectConfig" v-model="job.poNo" :disabled="readonly" no="21" />
        <cargo-project-select
          v-if="openProjectConfig"
          :disabled="readonly"
          no="22"
          :default-value="job.poNo"
          :customer-id="job.customerId"
          :is-linked="isProjectLinkedCustomer"
          @change="changeProject"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.visible" slot="plannerDepartment">
        <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
        <cargo-department-select
          no="plannerDepartment"
          :disabled="readonly"
          class="input2"
          :office-id="Number(job.plannerOffice)"
          :enables="true"
          :department-id="Number(job.plannerDepartment)"
          @change="p=>{job.plannerDepartment=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.visible" slot="plannerOffice">
        <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
        <cargo-advance-select
          no="plannerOffice"
          class="input2"
          :disabled="true"
          :select-type="TYPE_NAMES.basic_data_Office"
          filterable
          :default-value="job.plannerOffice||''"
          @parentCallBack="p=>{job.plannerOffice=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.projectName.visible && openProjectConfig" slot="projectName">
        <line-label slot="label" :class="elementDict.projectName.isRequire ? 'blue' : ''" :label="elementDict.projectName.label" />
        <el-input v-model="job.projectName" no="23" :disabled="true" />
      </el-form-item>
      <el-form-item v-if="elementDict.projectBatch.visible && openProjectConfig" slot="projectBatch">
        <line-label slot="label" :class="elementDict.projectBatch.isRequire ? 'blue' : ''" :label="elementDict.projectBatch.label" />
        <el-input v-model="job.projectBatch" :disabled="readonly" no="24" />
      </el-form-item>
      <template v-if="isAddUserDefinedRoles">
        <el-form-item v-if="elementDict.userDefinedRoleId1.visible" slot="userDefinedRoleId1">
          <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
          <cargo-user-select
            no="25"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
            :default-value="job.userDefinedRoleId1||''"
            :placeholder="$t('SeaExport.RequiredItem')"
            :static-options="userPortRoleData.userDefinedRole1"
            @change="userDefinedRoleId1Handler"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId2.visible" slot="userDefinedRoleId2">
          <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
          <cargo-user-select
            no="26"
            :disabled="readonly"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
            :default-value="job.userDefinedRoleId2||''"
            :placeholder="$t('SeaExport.RequiredItem')"
            :static-options="userPortRoleData.userDefinedRole2"
            @change="userDefinedRoleId2Handler"
          />
        </el-form-item>
      </template>
      <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.visible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
        <micro-app
          name="child-user-defined-role-remoteBooking-ae-userDefinedRoleId3"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChange"
        />
      </div>
      <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.visible && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
        <micro-app
          name="child-user-defined-role-remoteBooking-ae-userDefinedRoleId4"
          :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
          router-mode="pure"
          destroy
          @datachange="userDefinedRoleDataChange"
        />
      </div> -->
      <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.visible && isAddUserDefinedRoles" slot="userDefinedRoleId3">
        <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
        <cargo-user-select
          ref="userDefinedRoleId3"
          no="userDefinedRoleId3"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
          :default-value="job.userDefinedRoleId3||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole3"
          @change="p=>{userDefinedRoleId3Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.visible && isAddUserDefinedRoles" slot="userDefinedRoleId4">
        <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
        <cargo-user-select
          ref="userDefinedRoleId4"
          no="userDefinedRoleId4"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
          :default-value="job.userDefinedRoleId4||''"
          :merge-load="true"
          :static-options="userPortRoleData.userDefinedRole4"
          @change="p=>{userDefinedRoleId4Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.visible && isAddUserDefinedRoles" slot="userDefinedRoleId5">
        <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
        <cargo-user-select
          ref="userDefinedRoleId5"
          no="userDefinedRoleId5"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
          :default-value="job.userDefinedRoleId5||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId5Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.visible && isAddUserDefinedRoles" slot="userDefinedRoleId6">
        <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
        <cargo-user-select
          ref="userDefinedRoleId6"
          no="userDefinedRoleId6"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
          :default-value="job.userDefinedRoleId6||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId6Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.visible && isAddUserDefinedRoles" slot="userDefinedRoleId7">
        <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
        <cargo-user-select
          ref="userDefinedRoleId7"
          no="userDefinedRoleId7"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
          :default-value="job.userDefinedRoleId7||''"
          :merge-load="true"
          @change="p=>{userDefinedRoleId7Handler(p)}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
        <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
        <cargo-user-select
          ref="userDefinedRoleId8"
          no="userDefinedRoleId8"
          :disabled="readonly"
          :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
          :default-multiple-value="toNumArray(job.userDefinedRoleId8)"
          :multiple="true"
          :merge-load="true"
          :placeholder="readonly ? ' ' : ''"
          @change="p=>{job.userDefinedRoleId8=toTxt(p.value)}"
        />
      </el-form-item>
      <!-- <el-form-item v-show="elementDict.bookingRefuseNote.visible && job.preverifyState===3" slot="bookingRefuseNote">
        <line-label slot="label" :class="elementDict.bookingRefuseNote.isRequire ? 'blue' : ''" :label="elementDict.bookingRefuseNote.label" />
        <el-input v-model="job.bookingRefuseNote" no="27" type="textarea" :rows="3" :disabled="true" />
      </el-form-item> -->
      <el-form
        v-show="elementDict.shipper.visible"
        slot="shipper"
        label-width="50px"
        label-position="left"
        style="margin-right:10px"
      >
        <el-form-item>
          <line-label slot="label" :class="elementDict.shipper.isRequire ? 'blue' : ''" :label="elementDict.shipper.label" />
          <cargo-company-select
            no="28"
            :disabled="readonly"
            :method-params="{shipper:true,active:true}"
            :default-value="job.shipperId||''"
            placeholder=" "
            :static-options="hasChooseOwnTransceiverPermission ? privateShipperList : null"
            style="display: inline-block;width:196px;"
            @change="shipperChange"
          />
          <el-button
            no="29"
            :disabled="readonly"
            type="primary"
            style="margin-left: 5px;"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'shipperLine'+i"
            v-model="job['shipperLine'+i]"
            :disabled="readonly"
            no="30"
            :auto-uppercase="true"
            @change="()=>wrapAddr(job,'shipperLine'+i,i+1 > 7 ? null :'shipperLine'+(i+1),200)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),splitShipperLine,true)"
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.consignee.visible"
        slot="consignee"
        label-width="65px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <line-label slot="label" :class="elementDict.consignee.isRequire ? 'blue' : ''" :label="elementDict.consignee.label" />
          <cargo-company-select
            no="52"
            :disabled="readonly"
            :method-params="{consignee:true,active:true}"
            :default-value="job.consigneeId||''"
            placeholder=" "
            :static-options="hasChooseOwnTransceiverPermission ? privateConsigneeList : null"
            style="display: inline-block;width:196px;"
            @change="consigneeChange"
          />
          <el-button
            no="53"
            :disabled="readonly"
            type="primary"
            style="margin-left: 5px;"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'consigneeLine'+i"
            v-model="job['consigneeLine'+i]"
            :disabled="readonly"
            no="54"
            :auto-uppercase="true"
            @change="()=>wrapAddr(job,'consigneeLine'+i,i+1 > 7 ? null :'consigneeLine'+(i+1),200)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),splitConsigneeLine,true)"
          />
        </el-form-item>
      </el-form>
      <el-form
        v-show="elementDict.notify.visible"
        slot="notify"
        label-width="50px"
        label-position="left"
        style="margin-right:20px"
      >
        <el-form-item>
          <line-label slot="label" :class="elementDict.notify.isRequire ? 'blue' : ''" :label="elementDict.notify.label" />
          <cargo-company-select
            no="72"
            :disabled="readonly"
            :method-params="{notify:true,active:true}"
            :default-value="job.notifyId||''"
            placeholder=" "
            :static-options="hasChooseOwnTransceiverPermission ? privateNotifyList : null"
            style="display: inline-block;width:196px;"
            @change="notifyChange"
          />
          <el-button
            no="73"
            :disabled="readonly"
            type="primary"
            style="margin-left: 5px;"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}</el-button>
        </el-form-item>
        <el-form-item v-for="i in 7" :key="i" label-width="0">
          <cargo-input
            :ref="'notifyLine'+i"
            v-model="job['notifyLine'+i]"
            :disabled="readonly"
            no="74"
            :auto-uppercase="true"
            @change="()=>wrapAddr(job,'notifyLine'+i,i+1 > 7 ? null :'notifyLine'+(i+1),200)"
            @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),splitNotifyLine,true)"
          />
        </el-form-item>
      </el-form>
      <div v-if="elementDict.alsoNotify.visible" slot="alsoNotify">
        <line-label :class="elementDict.alsoNotify.isRequire ? 'blue' : ''" style="display:inline-block;line-height:28px;padding-bottom: 5px;" :label="elementDict.alsoNotify.label" />
        <br>
        <cargo-textarea
          v-model="job.alsoNotify"
          no="87"
          type="textarea"
          :rows="12"
          :disabled="readonly"
          class="also-notify"
          @dblclick.native="showAdvanceTextDialog(elementDict.alsoNotify.label,job.alsoNotify,val=>{job.alsoNotify=val},true,{warningCount:45,maxChar: 0})"
        />
      </div>
      <el-form-item v-if="elementDict.hsCode.visible" slot="hsCode">
        <line-label slot="label" :class="elementDict.hsCode.isRequire ? 'blue' : ''" :label="elementDict.hsCode.label" />
        <el-input
          v-model="job.hsCode"
          :disabled="readonly"
          no="hsCode"
          type="textarea"
          :rows="3"
          @dblclick.native="showAdvanceTextDialog(elementDict.hsCode.labe,job.hsCode,val=>{job.hsCode=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.etd.visible" slot="etd">
        <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
        <el-date-picker v-model="job.etd" :disabled="readonly" no="31" type="date" value-format="yyyy-MM-dd" clearable :placeholder="$t('SeaExport.RequiredItem')" @input="etdChange" />
      </el-form-item>
      <el-form-item v-if="elementDict.eta.visible" slot="eta">
        <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
        <el-date-picker v-model="job.eta" no="32" :disabled="readonly" type="date" value-format="yyyy-MM-dd" clearable />
      </el-form-item>
      <div v-if="elementDict.customsDate && elementDict.customsDate.visible && $store.getters.enableFrontEndPlugin" slot="customsDate">
        <micro-app
          name="child-operation-date-ae"
          :url="$store.getters.frontEndPluginUrl+'/operationDateItem'"
          router-mode="pure"
          destroy
          @datachange="operationDateDataChange"
        />
      </div>
      <el-form-item v-if="elementDict.customsDate && elementDict.customsDate.visible && !$store.getters.enableFrontEndPlugin" slot="customsDate">
        <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
        <el-date-picker v-model="job.customsDate" no="customsDate" :disabled="readonly" type="date" value-format="yyyy-MM-dd" clearable />
      </el-form-item>
      <el-form-item v-if="elementDict.dispatchingPlace.visible" slot="dispatchingPlace">
        <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
        <el-input
          v-model="job.dispatchingPlace"
          :disabled="readonly"
          no="33"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.loadingPortCode.visible" slot="loadingPortCode">
        <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
        <div style="display: flex;justify-content: space-between;width: 100%;">
          <el-input
            v-model="job.loadingPortCode"
            no="34"
            :disabled="true"
            style="width: 60px;"
          />
          <cargo-advance-select
            no="35"
            :disabled="readonly"
            filterable
            :select-type="TYPE_NAMES.basic_data_Airport"
            :default-value="job.loadingPortCode"
            :placeholder="$t('SeaExport.RequiredItem')"
            @parentCallBack="p=>{job.loadingPortCode=p.value;onLoadingPortCodeChange()}"
          />
        </div>
      </el-form-item>
      <template v-if="elementDict.destinationPortCode.visible" slot="destinationPortCode">
        <el-form-item>
          <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
          <div style="display: flex;justify-content: space-between;width: 100%;">
            <el-input
              v-model="job.destinationPortCode"
              no="36"
              :disabled="true"
              style="width: 60px;"
            />
            <cargo-advance-select
              no="37"
              :disabled="readonly"
              filterable
              :select-type="TYPE_NAMES.basic_data_Airport"
              :default-value="job.destinationPortCode"
              :placeholder="$t('SeaExport.RequiredItem')"
              @parentCallBack="destinationPortCodeChange"
            />
          </div>
        </el-form-item>
        <el-form-item label=" ">
          <div style="display: flex;justify-content: space-between">
            <el-checkbox v-model="job.transfering" :disabled="readonly" no="38" style="line-height: 28px;">{{ $t('SeaExport.Transit') }}</el-checkbox>
            <el-button
              no="39"
              :disabled="!job.transfering || readonly"
              type="primary"
              style="width: 100%;margin-left: 10px;"
              @click="showTransitPortDialog"
            >{{ $t('SeaExport.EnterTransitInfo') }}</el-button>
          </div>
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.destinationPlace.visible" slot="destinationPlace">
        <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
        <el-input v-model="job.destinationPlace" :disabled="readonly" no="40" @input="val=> job.destinationPlace = StrUtils.toUpperCase(val)" />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoType.visible" slot="cargoType">
        <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
        <cargo-advance-select
          no="41"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_CargoType"
          :method-params="{air:true}"
          :default-value="job.cargoType"
          :clearable="false"
          @parentCallBack="p=>{job.cargoType=p.value;onCargoTypeChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.loadingTerm.visible" slot="loadingTerm">
        <line-label slot="label" :class="elementDict.loadingTerm.isRequire ? 'blue' : ''" :label="elementDict.loadingTerm.label" />
        <cargo-advance-select
          no="42"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.local_cache_AirExportConstants$SUFFY_TYPES"
          :tag-name="isZh ? 'chineseName' : 'englishName'"
          :default-value="job.loadingTerm"
          :placeholder="$t('Message.PleaseSelect')"
          @parentCallBack="loadingTermChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoTerminalOperation && elementDict.cargoTerminalOperation.slaveVisible" slot="cargoTerminalOperation">
        <line-label slot="label" :class="elementDict.cargoTerminalOperation && elementDict.cargoTerminalOperation.isRequire ? 'blue' : ''" :label="elementDict.cargoTerminalOperation && elementDict.cargoTerminalOperation.label" />
        <cargo-advance-select
          no="cargoTerminalOperation"
          :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
          :method-params="{dataType:0, deletionFlag: false}"
          filterable
          :clearable="true"
          :default-value="job.cargoTerminalOperation"
          @parentCallBack="p=>{job.cargoTerminalOperation=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.estimatedDeliveryDate && elementDict.estimatedDeliveryDate.slaveVisible" slot="estimatedDeliveryDate">
        <line-label slot="label" :class="elementDict.estimatedDeliveryDate && elementDict.estimatedDeliveryDate.isRequire ? 'blue' : ''" :label="elementDict.estimatedDeliveryDate && elementDict.estimatedDeliveryDate.label" />
        <el-date-picker v-model="job.estimatedDeliveryDate" :disabled="!isEdit || !job.cargoTerminalOperation" no="estimatedDeliveryDate" type="date" value-format="yyyy-MM-dd" clearable />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermMBL.visible" slot="paymentTermMBL">
        <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
        <cargo-advance-select
          no="43"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_PaymentTerm"
          :default-value="job.paymentTermMBL"
          :clearable="false"
          @parentCallBack="p=>{job.paymentTermMBL=data.value;portChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.paymentTermHBL.visible && job.operateType!==2" slot="paymentTermHBL">
        <line-label slot="label" :class="elementDict.paymentTermHBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermHBL.label" />
        <cargo-advance-select
          no="44"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_PaymentTerm"
          filterable
          :clearable="false"
          :default-value="job.paymentTermHBL"
          :allow-create="true"
          @parentCallBack="p=>{job.paymentTermHBL=p.value;portChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoSource.visible" slot="cargoSource">
        <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
        <cargo-advance-select
          no="45"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.local_cache_CargoSource"
          :default-value="job.cargoSource"
          :clearable="false"
          @parentCallBack="p=>{job.cargoSource=p.value;selectFieldChangeHandler()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.agentRefNo.visible && job.cargoSource === 'NC'" id="agentRefNo" slot="agentRefNo">
        <line-label slot="label" :class="elementDict.agentRefNo.isRequire ? 'blue' : ''" :label="elementDict.agentRefNo.label" />
        <el-input v-model="job.agentRefNo" :disabled="readonly" no="agentRefNo" />
      </el-form-item>
      <el-form-item v-if="elementDict.customJobType.visible" slot="customJobType">
        <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
        <cargo-advance-select
          ref="customJobType"
          no="46"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_CutomJobType"
          :method-params="{type:job.lob, active: true}"
          :default-value="job.customJobType"
          :placeholder="$t('Message.PleaseSelect')"
          @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.destinationAgent.visible" slot="destinationAgent">
        <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
        <cargo-advance-select
          no="47"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_Company"
          filterable
          :method-params="{overseaAgent:true,active:true}"
          :default-value="job.destinationAgent||''"
          placeholder=" "
          @parentCallBack="txtDestinationAgentChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.designationAgent.visible && job.cargoSource==='NC'" slot="designationAgent">
        <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
        <cargo-company-select
          no="48"
          :disabled="readonly"
          :method-params="{designationAgent:true,active:true}"
          :check-credit="true"
          :job="job"
          :default-value="job.designationAgent||''"
          tag-name="englishName"
          placeholder=" "
          style="width: 100%"
          @change="txtDesignationAgentChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingAgent.visible && bookingAgentVisible" slot="bookingAgent">
        <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
        <cargo-advance-select
          no="49"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_Company"
          :method-params="{bookingAgent:true,companyLob:'airExport',active:true}"
          :default-value="job.bookingAgent || ''"
          placeholder=" "
          @parentCallBack="bookingAgentChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.carrierId.visible" slot="carrierId">
        <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
        <cargo-advance-select
          no="50"
          :disabled="readonly"
          filterable
          :select-type="TYPE_NAMES.basic_data_Company"
          :method-params="{airCmp:true,active:true}"
          :default-value="job.carrierId||''"
          placeholder=" "
          @parentCallBack="p=>{job.carrierId=p.value||0;onCarrierIdChange()}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.voyageFlight.visible" slot="voyageFlight">
        <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
        <el-input v-model="job.voyageFlight" :disabled="readonly" no="51" @change="voyageFlightCheckHandler" />
      </el-form-item>
      <el-form-item v-if="elementDict.quantityContract.visible" slot="quantityContract" class="auto-width">
        <line-label slot="label" :class="elementDict.quantityContract.isRequire ? 'blue' : ''" :label="elementDict.quantityContract.label" />
        <auto-number-input
          v-model="job.quantityContract"
          :disabled="readonly"
          no="55"
          :precision="0"
          :min="0"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.weightContract.visible" slot="weightContract">
        <line-label slot="label" :class="elementDict.weightContract.isRequire ? 'blue' : ''" :label="elementDict.weightContract.label" />
        <auto-number-input
          v-show="openImperial"
          v-model="job.weightContractImperial"
          :disabled="readonly"
          no="weightContractImperial"
          :precision="3"
          :min="0"
          @change="doWeightChangeHandler(true)"
        />
        <auto-number-input
          v-show="!openImperial"
          v-model="job.weightContract"
          :disabled="readonly"
          no="56"
          :precision="3"
          :min="0"
          @change="doWeightChangeHandler(false)"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cubageContract.visible" slot="cubageContract">
        <line-label slot="label" :class="elementDict.cubageContract.isRequire ? 'blue' : ''" :label="elementDict.cubageContract.label" />
        <auto-number-input
          v-show="openImperial"
          v-model="job.cubAgeContractImperial"
          :disabled="readonly"
          no="cubAgeContractImperial"
          :precision="3"
          :min="0"
          @change="doCuAgeChangeHandler(true)"
        />
        <auto-number-input
          v-show="!openImperial"
          v-model="job.cubageContract"
          :disabled="readonly"
          no="57"
          :precision="3"
          :min="0"
          @change="doCuAgeChangeHandler(false)"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.densityContract.visible" slot="densityContract">
        <line-label slot="label" :class="elementDict.densityContract.isRequire ? 'blue' : ''" :label="elementDict.densityContract.label" />
        <auto-number-input
          v-model="job.densityContract"
          :disabled="readonly"
          no="58"
          :precision="3"
          :min="0"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.packing.visible" slot="packing">
        <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
        <cargo-packing-select
          no="59"
          :disabled="readonly"
          :default-value="job.packing"
          placeholder=" "
          @change="p=>{job.packing=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.pbProportion.visible" slot="pbProportion">
        <line-label slot="label" :class="elementDict.pbProportion.isRequire ? 'blue' : ''" :label="elementDict.pbProportion.label" />
        <div style="display: flex;width: 100%">
          <template>
            <el-select
              v-if="splitBubbleCollectionFormat"
              :value="job.pbProportion||''"
              :disabled="readonly"
              no="60"
              clearable
              :filterable="!pbProportionCheck"
              :allow-create="!pbProportionCheck"
              @focus="onPbProportionFocus"
              @input="val=>{job.pbProportion=val}"
            >
              <el-option v-for="(item, index) in SPLIT_BUBBLE_COLLECT_ITEMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
            <template v-else>
              <el-input-number
                v-model="job.pbProportion"
                :disabled="readonly"
                no="60"
                style="margin-right: 0px"
                controls-position="right"
                :precision="0"
                :min="0"
                :max="100"
              />
              <span style="line-height: 28px;">%</span>
            </template>
          </template>
          <span :class="elementDict.pbProportion.isRequire ? 'blue' : ''" style="padding-left: 10px;padding-right: 5px;line-height: 28px;">{{ $t('SeaExport.pbProportion2') }}</span>
          <template>
            <el-select
              v-if="splitBubbleCollectionFormat"
              :value="job.pbProportion2||''"
              :disabled="readonly"
              no="61"
              clearable
              :filterable="!pbProportion2Check"
              :allow-create="!pbProportion2Check"
              @focus="onPbProportion2Focus"
              @input="val=>{job.pbProportion2=val}"
            >
              <el-option v-for="(item, index) in SPLIT_BUBBLE_COLLECT_ITEMS" :key="index" :label="$getLangColumn(item)" :value="item.code" />
            </el-select>
            <template v-else>
              <el-input-number
                v-model="job.pbProportion2"
                :disabled="readonly"
                no="61"
                controls-position="right"
                :precision="0"
                :min="0"
                :max="100"
              />
              <span style="line-height: 28px;">%</span>
            </template>
          </template>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.insideQuantity.visible" slot="insideQuantity">
        <line-label slot="label" :class="elementDict.insideQuantity.isRequire ? 'blue' : ''" :label="elementDict.insideQuantity.label" />
        <auto-number-input
          v-model="job.insideQuantity"
          :disabled="readonly"
          no="62"
          :precision="0"
          :min="0"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.chargeWeight && elementDict.chargeWeight.visible && openImperial" slot="chargeWeight">
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <div style="display: flex;width: 100%">
          <el-input-number
            v-model="job.chargeWeightImperial"
            :disabled="true"
            no="chargeWeightImperial"
            :controls="false"
            :precision="3"
            style="width: auto;flex-grow: 1;"
          />
          <span style="line-height: 28px;">LB</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.chargeWeight && elementDict.chargeWeight.visible && !openImperial" slot="chargeWeight">
        <line-label slot="label" :class="elementDict.chargeWeight.isRequire ? 'blue' : ''" :label="elementDict.chargeWeight.label" />
        <div style="display: flex;width: 100%">
          <el-input-number
            v-model="job.chargeWeight"
            :disabled="readonly"
            no="63"
            :controls="false"
            :precision="3"
            style="width: auto;flex-grow: 1;"
          />
          <span style="line-height: 28px;">M/T</span>
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.insidePacking.visible" slot="insidePacking">
        <line-label slot="label" :class="elementDict.insidePacking.isRequire ? 'blue' : ''" :label="elementDict.insidePacking.label" />
        <cargo-packing-select
          no="64"
          :disabled="readonly"
          :default-value="job.insidePacking"
          placeholder=" "
          @change="p=>{job.insidePacking=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.measurements.visible" slot="measurements">
        <line-label slot="label" :class="elementDict.measurements.isRequire ? 'blue' : ''" :label="elementDict.measurements.label" />
        <el-input
          v-model="job.measurements"
          :disabled="readonly"
          no="65"
          type="textarea"
          :rows="3"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Size'),job.measurements,val=>{job.measurements=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.frontEndWarehouseOperation && elementDict.frontEndWarehouseOperation.slaveVisible" slot="frontEndWarehouseOperation">
        <line-label slot="label" :class="elementDict.frontEndWarehouseOperation.isRequire ? 'blue' : ''" :label="elementDict.frontEndWarehouseOperation && elementDict.frontEndWarehouseOperation.label" />
        <cargo-advance-select
          no="frontEndWarehouseOperation"
          :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
          :method-params="{dataType:1, deletionFlag: false}"
          filterable
          :clearable="true"
          :default-value="job.frontEndWarehouseOperation"
          @parentCallBack="p=>{job.frontEndWarehouseOperation=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.estimatedDateOfWarehousinge.visible" slot="estimatedDateOfWarehousinge">
        <line-label slot="label" :class="elementDict.estimatedDateOfWarehousinge.isRequire ? 'blue' : ''" :label="elementDict.estimatedDateOfWarehousinge.label" />
        <el-date-picker
          v-model="job.estimatedDateOfWarehousinge"
          :disabled="readonly"
          no="66"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          clearable
        />
      </el-form-item>
      <el-form-item v-if="elementDict.estimatedDeliveryTime.visible" slot="estimatedDeliveryTime">
        <line-label slot="label" :class="elementDict.estimatedDeliveryTime.isRequire ? 'blue' : ''" :label="elementDict.estimatedDeliveryTime.label" />
        <el-date-picker
          v-model="job.estimatedDeliveryTime"
          :disabled="readonly"
          no="67"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
          clearable
        />
      </el-form-item>
      <el-form-item v-if="elementDict.incoTerm.visible" slot="incoTerm">
        <line-label slot="label" :class="elementDict.incoTerm.isRequire ? 'blue' : ''" :label="elementDict.incoTerm.label" />
        <cargo-advance-select
          no="68"
          :disabled="readonly"
          :select-type="TYPE_NAMES.basic_data_IncoTerm"
          filterable
          :clearable="false"
          :default-value="job.incoTerm"
          @parentCallBack="p=>{job.incoTerm=p.value}"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.bookingTerm.visible" slot="bookingTerm">
        <line-label slot="label" :class="elementDict.bookingTerm.isRequire ? 'blue' : ''" :label="elementDict.bookingTerm.label" />
        <el-select v-model="job.bookingTerm" :disabled="readonly" no="69" :clearable="false" size="mini">
          <el-option
            v-for="(item,index) in bookingTerms"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <template v-if="elementDict.customClaim.visible" slot="customClaim">
        <el-form-item>
          <line-label slot="label" :class="elementDict.customClaim.isRequire ? 'blue' : ''" :label="elementDict.customClaim.label" />
          <cargo-advance-select
            no="70"
            :disabled="readonly"
            filterable
            :select-type="selectTypeNames.local_cache_AirExportConstants$CUSTOM_CLAIMS"
            :default-value="job.customClaim"
            :tag-name="isZh?'chineseName':'englishName'"
            :fields="['chineseName']"
            @parentCallBack="p=>{job.customClaim=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="Number(job.customClaim) === 1" :label="$t('SeaExport.CustomsDeclarationType')">
          <cargo-advance-select
            no="71"
            :disabled="readonly"
            filterable
            :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
            :default-value="job.customsClaim2 || 0"
            @parentCallBack="p=>{job.customsClaim2=p.value;job.customsDeclarationType=p.value}"
          />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.cargoChineseName.visible" slot="cargoChineseName">
        <line-label slot="label" :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
        <cargo-textarea
          v-model="job.cargoChineseName"
          no="75"
          type="textarea"
          :rows="3"
          :disabled="!isEdit"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,val=>{job.cargoChineseName=val}, true, {autoUppercase:true})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.cargoEnglishName.visible" slot="cargoEnglishName">
        <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
        <cargo-textarea
          v-model="job.cargoEnglishName"
          no="76"
          type="textarea"
          :rows="3"
          :disabled="!isEdit"
          :auto-uppercase="isUppercaseByConfig"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,val=>{job.cargoEnglishName=val}, isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.mark.visible" slot="mark">
        <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
        <cargo-textarea
          v-model="job.mark"
          no="77"
          type="textarea"
          :rows="3"
          :disabled="!isEdit"
          :auto-uppercase="isUppercaseByConfig"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,val=>{job.mark=val},isUppercaseByConfig, {autoUppercase:isUppercaseByConfig})"
        />
      </el-form-item>
      <template v-if="elementDict.cargoCode.visible" slot="cargoCode">
        <el-form-item>
          <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
          <cargo-advance-select
            no="78"
            :disabled="readonly"
            :select-type="TYPE_NAMES.basic_data_CargoInformation"
            filterable
            :callback-params="{key:'cargoCode'}"
            :default-value="job.cargoCode"
            :placeholder="$t('queryJob.ClickSelectTheGoodsCode')"
            @parentCallBack="txtCargoInformationChangeHandler"
          />
        </el-form-item>
        <el-form-item>
          <el-input v-model="job.cargoName" no="79" :disabled="!job.cargoCode || readonly" />
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.carryingCmp.visible && !isSalesForSzfs" slot="carryingCmp">
        <line-label slot="label" :class="elementDict.carryingCmp.isRequire ? 'blue' : ''" :label="elementDict.carryingCmp.label" />
        <cargo-company-select
          no="80"
          :disabled="!job.landTransportation || readonly"
          :method-params="{truckCmp:true,active:true}"
          :default-value="job.carryingCmp||''"
          :placeholder="$t('SeaExport.PleaseTickDoorLoadingDeliveryOption')"
          style="width: 100%"
          @change="carryingCmpChangeHandler"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.selling.visible" slot="selling">
        <line-label slot="label" :class="elementDict.selling.isRequire ? 'blue' : ''" :label="elementDict.selling.label" />
        <div style="display: flex;justify-content: space-between">
          <el-input v-model="job.selling" :disabled="readonly" style="width:120px;margin-right: 5px;" no="81" @blur="sellingOrBuyingChangeHandler" />
          <cargo-advance-select
            filterable
            no="sellingCurrency"
            :placeholder="' '"
            :select-type="selectTypeNames.basic_data_Currency"
            :disabled="readonly"
            :default-value="job.sellingCurrency"
            style="flex:1"
            :clearable="false"
            @parentCallBack="p=>{job.sellingCurrency=p.code}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.buying.visible" slot="buying">
        <line-label slot="label" :class="elementDict.buying.isRequire ? 'blue' : ''" :label="elementDict.buying.label" />
        <div style="display: flex;justify-content: space-between">
          <el-input v-model="job.buying" :disabled="readonly" style="width:120px;margin-right: 5px;" no="82" @blur="sellingOrBuyingChangeHandler" />
          <cargo-advance-select
            filterable
            no="buyingCurrency"
            :placeholder="' '"
            :select-type="selectTypeNames.basic_data_Currency"
            :disabled="readonly"
            :default-value="job.buyingCurrency"
            :clearable="false"
            style="flex:1"
            @parentCallBack="p=>{job.buyingCurrency=p.code}"
          />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.sellPriceType && elementDict.sellPriceType.viewable" slot="sellPriceType" :label="elementDict.sellPriceType.label">
        <el-select
          v-model="job.sellPriceType"
          :disabled="readonly"
          :placeholder="$t('Message.PleaseSelect')"
          size="mini"
          no="sellPriceType"
        >
          <el-option
            v-for="(item,index) in SELL_BUY_PRICE"
            :key="index"
            :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.buyPriceType && elementDict.buyPriceType.viewable" slot="buyPriceType" :label="elementDict.buyPriceType.label">
        <el-select
          v-model="job.buyPriceType"
          :disabled="readonly"
          :placeholder="$t('Message.PleaseSelect')"
          size="mini"
          no="buyPriceType"
        >
          <el-option
            v-for="(item,index) in SELL_BUY_PRICE"
            :key="index"
            :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.doorName.visible && job.loadingTerm==='DD'" slot="doorName">
        <line-label slot="label" :class="elementDict.doorName.isRequire ? 'blue' : ''" :label="elementDict.doorName.label" />
        <el-select
          v-model="truckingInfo.doorName"
          :disabled="readonly"
          no="83"
          value-key="name"
          clearable
          filterable
          :allow-create="true"
          @change="doorsChangeHandler"
        >
          <el-option
            v-for="(item,index) in doorList"
            :key="index"
            :label="item.name"
            :value="item.name"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="elementDict.contactPerson.visible && job.loadingTerm==='DD'" slot="contactPerson">
        <line-label slot="label" :class="elementDict.contactPerson.isRequire ? 'blue' : ''" :label="elementDict.contactPerson.label" />
        <div style="display: flex">
          <el-input v-model="truckingInfo.doorMan" :disabled="readonly" no="84" :placeholder="$t('Payment.contactPerson')" />
          <div :class="elementDict.contactPerson.isRequire ? 'blue' : ''" style="width: 65px;padding:0 10px;font-size: 12px;">{{ $t('SeaExport.Tel') }}</div>
          <el-input v-model="truckingInfo.doorManTel" :disabled="readonly" no="85" :placeholder="$t('SeaExport.Tel')" />
        </div>
      </el-form-item>
      <el-form-item v-if="elementDict.doorAddr.visible && job.loadingTerm==='DD'" slot="doorAddr">
        <line-label slot="label" :class="elementDict.doorAddr.isRequire ? 'blue' : ''" :label="elementDict.doorAddr.label" />
        <el-input
          v-model="truckingInfo.doorAddr"
          :disabled="readonly"
          no="doorAddr"
          type="textarea"
          :rows="3"
          @dblclick.native="showAdvanceTextDialog(elementDict.doorAddr.label,truckingInfo.doorAddr,val=>{truckingInfo.doorAddr=val})"
        />
      </el-form-item>
      <template v-if="elementDict.portOfDestinationServices.visible" slot="portOfDestinationServices">
        <el-form-item>
          <line-label slot="label" :class="elementDict.portOfDestinationServices.isRequire ? 'blue' : ''" :label="elementDict.portOfDestinationServices.label" />
          <el-checkbox
            v-model="job.dischargingPortDoor"
            :disabled="readonly"
            no="dischargingPortDoor"
            style="display: block;"
          >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox
            v-model="job.usCustomsClearance"
            :disabled="readonly"
            no="usCustomsClearance"
            style="display: block;"
          >{{ $t('queryJob.UsCustomsClearance') }}
          </el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-checkbox
            v-model="job.destPortCustomsClearance"
            :disabled="readonly"
            no="destPortCustomsClearance"
            style="display: block;"
          >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
          </el-checkbox>
        </el-form-item>
      </template>
      <el-form-item v-if="elementDict.exChangeAgent.visible" slot="exChangeAgent">
        <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
        <cargo-company-select
          no="exChangeAgent"
          :disabled="!job.dischargingPortDoor || readonly"
          :method-params="{bookingAgent:true,active:true}"
          :default-value="job.exChangeAgent||''"
          style="width: 100%"
          @change="onExChangeAgentChange"
        />
      </el-form-item>
      <el-form-item v-show="elementDict.satisfiedRequests.visible" slot="satisfiedRequests" class="auto-width">
        <special-requests-grid
          ref="selectedSpecialRequest"
          v-model="job.satisfiedRequests"
          no="88"
          :is-edit="isEdit"
          :customer-id="job.customerId"
          :lob="job.lob"
          :job="job"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.remarks.visible" slot="remarks" class="auto-width">
        <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
        <el-input
          v-model="job.remarks"
          :disabled="readonly"
          no="89"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,val=>{job.remarks=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField1.visible" slot="userDefinedField1" class="auto-width">
        <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
        <el-input
          v-model="job.userDefinedField1"
          :disabled="readonly"
          no="90"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,job.userDefinedField1,val=>{job.userDefinedField1=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField2.visible" slot="userDefinedField2" class="auto-width">
        <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
        <el-input
          v-model="job.userDefinedField2"
          :disabled="readonly"
          no="91"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,job.userDefinedField2,val=>{job.userDefinedField2=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField3.visible" slot="userDefinedField3" class="auto-width">
        <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
        <el-input
          v-model="job.userDefinedField3"
          :disabled="readonly"
          no="92"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,job.userDefinedField3,val=>{job.userDefinedField3=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.userDefinedField4.visible" slot="userDefinedField4" class="auto-width">
        <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
        <el-input
          v-model="job.userDefinedField4"
          :disabled="readonly"
          no="93"
          type="textarea"
          :rows="4"
          @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,job.userDefinedField4,val=>{job.userDefinedField4=val})"
        />
      </el-form-item>
      <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.visible" slot="taxNature" class="auto-width">
        <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
        <el-select
          v-model="job.taxNature"
          :disabled="readonly"
          no="taxNature"
          :placeholder="$t('SeaExport.PleaseSelect')"
        >
          <el-option
            v-for="(item,index) in TAX_NATURES"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
      <el-form-item v-if="elementDict.rateType && elementDict.rateType.slaveVisible" slot="rateType">
        <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
        <el-select
          v-model="job.rateType"
          :disabled="readonly"
          no="rateType"
          clearable
          :placeholder="$t('SeaExport.PleaseSelect')"
          size="mini"
        >
          <el-option
            v-for="(item,index) in rateType"
            :key="index"
            :label="isZh?item.chineseName:item.englishName"
            :value="item.code"
          />
        </el-select>&nbsp;
      </el-form-item>
    </tab-ae-booking-UICustom-layout>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      :own-permission="hasChooseOwnTransceiverPermission"
      :customer-cmp-list="customerCmpList"
      :use-empty-customer-cmp-list="true"
      @callback="codeSearchCallback"
    />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        :auto-uppercase="advanceTextDialog.formatObj.autoUppercase"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button
          v-show="isEdit"
          type="primary"
          @click="finishAdvanceText"
        >{{ $t('common.btn.confirm') }}</el-button>
        <el-button @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 中转信息弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="transitPortDialog.visible"
      :title="$t('SeaExport.TransitInformation')"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="transit-port-dialog"
    >
      <el-row :gutter="20">
        <el-col :span="10" :offset="4" style="font-weight: bold;text-align: center;">{{ $t('SeaExport.SecondCheck') }}</el-col>
        <el-col :span="10" style="font-weight: bold;text-align: center;">{{ $t('SeaExport.ThreeWay') }}</el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 5px;">
        <el-col :span="4">To</el-col>
        <el-col :span="10">
          <cargo-advance-select
            no="94"
            filterable
            :select-type="TYPE_NAMES.basic_data_Airport"
            :default-value="transitPortDialog.form.secondPortCode"
            @parentCallBack="p=>{transitPortDialog.form.secondPortCode=p.value}"
          />
        </el-col>
        <el-col :span="10">
          <cargo-advance-select
            no="95"
            filterable
            :select-type="TYPE_NAMES.basic_data_Airport"
            :default-value="transitPortDialog.form.thirdPortCode"
            @parentCallBack="p=>{transitPortDialog.form.thirdPortCode=p.value}"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="4">By</el-col>
        <el-col :span="10">
          <cargo-advance-select
            no="96"
            filterable
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true}"
            :default-value="transitPortDialog.form.secondCarrierId||''"
            @parentCallBack="p=>{transitPortDialog.form.secondCarrierIdd=p.value||0}"
          />
        </el-col>
        <el-col :span="10">
          <cargo-advance-select
            no="97"
            filterable
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true}"
            :default-value="transitPortDialog.form.thirdCarrierId||''"
            @parentCallBack="p=>{transitPortDialog.form.thirdCarrierId=p.value||0}"
          />
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="4">Flight</el-col>
        <el-col :span="10">
          <el-input v-model="transitPortDialog.form.secondFlight" no="98" />
        </el-col>
        <el-col :span="10">
          <el-input v-model="transitPortDialog.form.thirdFlight" no="99" />
        </el-col>
      </el-row>
      <el-row :gutter="20" style="margin-top: 10px;">
        <el-col :span="4">MAWB</el-col>
        <el-col :span="10">
          <el-input v-model="transitPortDialog.form.secondMAWB" no="100" />
        </el-col>
        <el-col :span="10">
          <el-input v-model="transitPortDialog.form.thirdMAWB" no="101" />
        </el-col>
      </el-row>
      <span slot="footer">
        <el-button
          v-show="isEdit"
          no="102"
          type="primary"
          @click="confirmTransitPort"
        >{{ $t('common.btn.ok') }}</el-button>
        <el-button no="103" @click="transitPortDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabAeBookingUICustomLayout from '@/views/cargo/v0/Sales/components/remoteBooking/tabs/tabAeBookingUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabAeBooking from '@/views/cargo/v0/Sales/components/remoteBooking/tabs/tabAeBooking.vue'
import StrUtils from '@/utils/StrUtils'
import { Office } from '@/class/model/sys/Office'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'TabAeBookingUICustom',
  components: { cargoTextarea, tabAeBookingUICustomLayout },
  extends: tabAeBooking,
  props: {
    previewConfig: { type: Object, default: null }
  },
  data() {
    return {
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      operationDateData: { // 子应用操作日期
        filedLable: 'SeaExport.OperationDate',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'operationDate',
        fieldData: this.job ? this.job.customsDate : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: ''
      },
      userDefinedRoleData: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.job ? this.job.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    }
  },
  created() {
    this.loadPageConfig()
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
    },
    // 销售部门修改后，调整分公司信息
    async departmentChargeHandler(data) {
      const job = this.job
      job.salesDepartment = data.value
      if (job.salesDepartment > 0) {
        const office = await Office.getOfficeByUuid(data.officeUuid)
        if (office && job.salesOffice !== office.officeId) {
          job.salesOffice = office.officeId
          this.loadCompanyOffice()
        }
      }
    },
    loadPageConfig() {
      if (this.previewConfig) {
        this.elementBlocks = this.previewConfig.elementBlocks
        this.elementDict = this.previewConfig.elementDict
        this.fieldDict = this.previewConfig.fieldDict
      } else {
        const pageConfig = UICustomUtil.getPageConfig(UICustomConstants.REMOTE_AIR_BOOKING_BASIC, this.$store.getters.currentOfficeId)
        this.elementBlocks = pageConfig.elementBlocks
        this.elementDict = pageConfig.elementDict
        this.fieldDict = pageConfig.fieldDict
      }
    },
    async validateForm() {
      const form = this.job
      for (const name in this.elementDict) {
        const element = this.elementDict[name]
        if (element.fieldNames && element.fieldNames.length > 0) {
          for (const key of element.fieldNames) {
            const field = this.fieldDict[key]
            const label = element.fieldNames.length > 1 ? field.label : element.label
            if (element.visible && element.isRequire) {
              if (key === 'projectName' || key === 'projectBatch') {
                if (!this.openProjectConfig) {
                  continue
                }
              }
              if (key === 'userDefinedRoleId1' || key === 'userDefinedRoleId2') {
                if (!this.isAddUserDefinedRoles) {
                  continue
                }
              }
              if (key === 'shipperLine1') {
                let shipperLine = ''
                for (let i = 1; i <= 7; ++i) {
                  shipperLine += form['shipperLine' + i]
                }
                if (StrUtils.isEmpty(shipperLine)) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabAeBooking')
                }
                continue
              }
              if (key === 'consigneeLine1') {
                let consigneeLine = ''
                for (let i = 1; i <= 7; ++i) {
                  consigneeLine += form['consigneeLine' + i]
                }
                if (StrUtils.isEmpty(consigneeLine)) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabAeBooking')
                }
                continue
              }
              if (key === 'notifyLine1') {
                let notifyLine = ''
                for (let i = 1; i <= 7; ++i) {
                  notifyLine += form['notifyLine' + i]
                }
                if (StrUtils.isEmpty(notifyLine)) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabAeBooking')
                }
                continue
              }
              if (key.startsWith('shipperLine') || key.startsWith('consigneeLine') || key.startsWith('notifyLine')) {
                continue
              }
              if (key.startsWith('shipperCode') || key.startsWith('consigneeCode') || key.startsWith('notifyCode')) {
                continue
              }
              if (key === 'designationAgent') {
                if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabAeBooking')
                }
              } else if (key === 'cargoCode') {
                if (StrUtils.isEmpty(form.cargoCode) || StrUtils.isEmpty(form.cargoName)) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabAeBooking')
                }
              } else if (key === 'customClaim') {
                if (!AirExportConstants.CUSTOM_CLAIMS[form.customClaim]) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabAeBooking')
                }
              } else if (key === 'pbProportion') {
                if (!form.pbProportion) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabAeBooking')
                }
                if (!form.pbProportion2) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.pbProportion2')]), 'tabAeBooking')
                }
              } else if (key === 'insideQuantity') {
                if (!form.insideQuantity) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabAeBooking')
                }
              } else if (key === 'taxNature') {
                if (form[key] === '' || form[key] === null) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'tabBookingFCL')
                }
              } else {
                if (typeof form[key] !== 'boolean' && StrUtils.isEmpty(form[key])) {
                  throw new TabError(this.$t('Message.FieldValueCannotBeNull', [label]), 'tabAeBooking')
                }
              }
            }
          }
        }
      }
      if (form.loadingTerm === 'DD') {
        if (this.elementDict.doorName.visible && this.elementDict.doorName.isRequire) {
          if (StrUtils.isEmpty(this.truckingInfo.doorName)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.doorName.label]), 'tabAeBooking')
          }
        }
        if (this.elementDict.contactPerson.visible && this.elementDict.contactPerson.isRequire) {
          if (StrUtils.isEmpty(this.truckingInfo.doorMan)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.contactPerson.label]), 'tabAeBooking')
          }
          if (StrUtils.isEmpty(this.truckingInfo.doorManTel)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.$t('SeaExport.Tel')]), 'tabAeBooking')
          }
        }
        if (this.elementDict.doorAddr.visible && this.elementDict.doorAddr.isRequire) {
          if (StrUtils.isEmpty(this.truckingInfo.doorAddr)) {
            throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.doorAddr.label]), 'tabAeBooking')
          }
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setOperationDateData() {
      this.operationDateData.fieldData = this.job.customsDate
      this.operationDateData.disabled = this.readonly
      console.log('主应用发送OperationDate:', this.operationDateData)
      microApp.forceSetData('child-operation-date-ae', this.operationDateData)
    },
    operationDateDataChange(e) {
      console.log('主应用获取OperationDate:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setOperationDateData()
        } else {
          this.job.customsDate = e.detail.data.fieldData
        }
      }
    },
    setUserDefinedRoleData() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleData }
      userDefinedRoleData3.fieldData = this.job.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-remoteBooking-ae-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleData }
      userDefinedRoleData4.fieldData = this.job.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-remoteBooking-ae-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChange(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleData()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.job.userDefinedRoleId3 = e.detail.data.fieldData
            this.userDefinedRoleId3Handler(this.job.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.job.userDefinedRoleId4 = e.detail.data.fieldData
            this.userDefinedRoleId4Handler(this.job.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ {
  .job-no-color.el-input {
    .el-input__inner {
      background: #ffffcc !important;
    }
  }
  .el-form-item__content {
    white-space: nowrap;
    display: flex;
    flex-direction: row;
    .el-date-editor {
      width: 100%;
    }
  }
  .auto-width {
    .el-form-item__content {
      width: auto;
    }
  }
}
.transit-port-dialog ::v-deep {
  .el-select {
    width: 100%;
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
/deep/ .also-notify {
  width: 310px;
  .el-textarea__inner {
    height: 230px;
  }
}
</style>
